import React from 'react';
import EnglishFonts from './DesignerSettings/englishFonts';
import ImageList from './DesignerSettings/imageList';
import ShirtSettings from './DesignerSettings/shirtSettings';
import {VscThreeBars} from 'react-icons/vsc'



const DesignerSettings = ({props,onZoomClicked}) => {
    return (<React.Fragment>
        <button id='expandButton' onClick={onZoomClicked} style={{width:"40px",height:"40px",background:"transparent",border:'none',position:'relative',float:'right',margin:0,padding:0,visibility:'hidden'}} ><VscThreeBars color='ghostwhite' size={40}/></button>
        <div id="settingsContainer">
        {props.designer.activeMenuTab==="shirtSettings"?(<ShirtSettings props={props}/>):
        props.designer.activeMenuTab==="printSettings"?(<ImageList props={props}/>):(<EnglishFonts props={props}/>)} 
    </div>
    </React.Fragment>);
}
 
export default DesignerSettings;